<template>
    <header v-title data-title="雪迹小程序教练报名">
  <div class="home">
    <!-- <h1 class="title">
      只为雪友寻找优质教练
    </h1>
    <div class="desc">
      <br>
      不绑定平台 平台不抽成 免费推广
      <br>
      必须有证（不限国籍教练证）
    </div> -->
    <div class="form" v-if="!isEidtShow">
      <van-form @failed="onFailed">
      <div class="form-item form-item--required"  data-name="userName">
        <div class="title-container">
        <h2 class="user-info-h1">
          请填写您的信息
        </h2>
        <div class="title-btn" @click="handleEidt"><van-icon class="icon" name="edit" />修改教练信息</div>
        </div>
        
        <div class="user-div">
          只为雪友寻找优质教练
        </div>
        <div class="form-item__label">
          <span>
            .
          </span>
          昵称
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.coachNickName"
            placeholder="请输入昵称或姓名"
            :rules="[{ required: true, message: ' ' },
              { validator, message: '请输入正确内容' }
            ]"
          />
        </div>
      </div>

      <div class="form-item form-item--required" data-name="gender">
        <div class="form-item__label">
          <span>
            .
          </span>
          头像
        </div>
        <div class="form-item__content">
          <van-field name="uploader">
            <template #input>
              <van-uploader v-model="photo.uploader" @click-upload="btn(0)" @delete="deleteP0o0" :after-read="afterReadUpload0" :max-count="1" />
            </template>
          </van-field>
        </div>
      </div>

      <div class="form-item form-item--required" data-name="phone">
        <div class="form-item__label">
          <span>
            ·
          </span>
          类型
        </div>
        <div class="form-item__content">
          <van-field
            readonly
            clickable
            name="picker"
            :value="skiType"
            placeholder="点击选择单双板类型"
            @click="showPicker = true"
            :rules="[
              { required: true, message: '' }
            ]"
          />
          <van-popup v-model="showPicker" round position="bottom" style="height:42%">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
        </div>
      </div>

      <div class="form-item form-item--required" data-name="phone">
        <div class="form-item__label">
          <span>
            ·
          </span>
          常驻雪场
        </div>
        <div class="form-item__content">
          <van-field
            readonly
            clickable
            name="picker"
            :value="residentResort"
            placeholder="请选择常驻地"
            @click="showCity = true"
            :rules="[
              { required: true, message: '' }
            ]"
          />
          <van-popup v-model="showCity" round position="bottom" style="height:42%">
            <van-picker
              show-toolbar
              :columns="skiResortList"
              @confirm="onConfirm"
              @cancel="showCity = false"
            />
          </van-popup>
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          擅长教学
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.skiStyle"
            placeholder="请填写擅长的教学"
            clearable
            :rules="[{ required: true, message: '' }]"
          />
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          个人简介
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.desc"
            placeholder="请填写个人简介"
            autosize
            clearable
            type="textarea"
            :rules="[{ required: true, message: '' }]"
          />
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          雪龄
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.allSkiYears"
            name="patternYears"
            placeholder="请输入雪龄"
            type="number"
            :rules="[
              { required: true, message: '' }
            ]"
          />
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          教龄
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.authSkiYears"
            placeholder="请输入教龄"
            clearable
            type="number"
            :rules="[
              { required: true, message: '' }
            ]"
          />
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          3小时价格
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.threeHourPrice"
            placeholder="请填写3小时价格"
            clearable
            type="number"
            :rules="[
              { required: true, message: '' }
            ]"
          />
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          全天价格
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.dayPrice"
            placeholder="请填写全天价格"
            type="number"
            clearable
            :rules="[
              { required: true, message: '' }
            ]"
          />
        </div>
      </div>

      <div class="form-item form-item--required" >
        <div class="form-item__label">
          <span>
            .
          </span>
          教练体系
        </div>
        <div class="form-item__content">
          <van-field
            readonly
            clickable
            name="picker"
            :value="valueSystem"
            placeholder="请选择教练体系"
            @click="showSystem = true"
            :rules="[
              { required: true, message: '' }
            ]"
          />
          <van-popup  v-model="showSystem" round position="bottom" style="height:42%">
            <van-picker
              show-toolbar
              value-key="name"
              :columns="systemList"
              @confirm="onConfirm"
              @cancel="showSystem = false"
            />
          </van-popup>
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          教练等级
        </div>
        <div class="form-item__content">
          <van-field
            readonly
            clickable
            name="picker"
            :value="params.coachLevel"
            placeholder="请选择教练等级"
            @click="showRank = true"
            :rules="[
              { required: true, message: '' }
            ]"

          />
          <van-popup v-model="showRank" position="bottom" style="height:42%">
            <van-picker
              show-toolbar
              :columns="rankList"
              @confirm="onConfirm"
              @cancel="showRank = false"
            />
          </van-popup>
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          认证资料
        </div>
        <div class="form-item__content">
          <van-field name="uploader">
            <template #input>
              <van-uploader v-model="authDoc.uploader" @click-upload="btn(1)" :max-count="3" @delete="deleteP0o1" :after-read="afterReadUpload1" />
            </template>
          </van-field>
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          个人作品视频
         <p class="p-style">30M内,等其他视频上传完上传新视频</p>
        </div>
        <div class="form-item__content">
          <van-field name="uploader">
            <template #input>
              <van-uploader v-model="personVideo[0].uploader" @click-upload="btn(2)" :max-count="1" @delete="deleteP0o2" :after-read="afterReadUpload2"
              accept="video/mp4, video/mov, video/m4v, video/3gp, video/avi, video/m3u8, video/webm"
              :max-size="30000 * 1024" @oversize="onOversize" >
                <template #preview-cover="{ }">
                  <div class="preview-cover van-ellipsis">上传成功</div>
                </template>
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          学员视频1
            <p class="p-style">30M内,等其他视频上传完上传新视频</p>
        </div>
        <div class="form-item__content">
          <van-field name="uploader">
            <template #input>
              <van-uploader v-model="studentVideo[0].uploader" @click-upload="btn(3)" :max-count="1" @delete="deleteP0o3" :after-read="afterReadUpload3"
              accept="video/mp4, video/mov, video/m4v, video/3gp, video/avi, video/m3u8, video/webm"
              :max-size="30000 * 1024" @oversize="onOversize" >
              <template #preview-cover="{ }">
                  <div class="preview-cover van-ellipsis">上传成功</div>
                </template>
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          学员视频描述1
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.studentVideo[0].videoDesc"
            placeholder="视频描述"
            clearable
            :rules="[
              { required: true, message: '' }
            ]"
          />
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          学员视频2(非必填)
          <p class="p-style">30M内,等其他视频上传完上传新视频</p>
        </div>
        <div class="form-item__content">
          <van-field name="uploader">
            <template #input>
              <van-uploader v-model="studentVideo[1].uploader" @click-upload="btn(4)" :max-count="1" @delete="deleteP0o4" :after-read="afterReadUpload4"
              accept="video/mp4, video/mov, video/m4v, video/3gp, video/avi, video/m3u8, video/webm"
              :max-size="30000 * 1024" @oversize="onOversize">
              <template #preview-cover="{ }">
                  <div class="preview-cover van-ellipsis">上传成功</div>
                </template>
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          学员视频描述2(非必填)
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.studentVideo[1].videoDesc"
            placeholder="请输入视频描述"
            clearable
          />
        </div>
      </div>

        <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          学员视频3(非必填)
          <p class="p-style">30M内,等其他视频上传完上传新视频</p>
        </div>
        <div class="form-item__content">
          <van-field name="uploader">
            <template #input>
              <van-uploader v-model="studentVideo[2].uploader" @click-upload="btn(5)" :max-count="1" @delete="deleteP0o5" :after-read="afterReadUpload5"
              accept="video/mp4, video/mov, video/m4v, video/3gp, video/avi, video/m3u8, video/webm"
              :max-size="30000 * 1024" @oversize="onOversize" >
              <template #preview-cover="{ }">
                  <div class="preview-cover van-ellipsis">上传成功</div>
                </template>
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          学员视频描述3(非必填)
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.studentVideo[2].videoDesc"
            placeholder="请输入视频描述"
            clearable
          />
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          联系方式
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.contactDatails"
            placeholder="请输入手机号或微信号"
            clearable
            :rules="[
              { required: true, message: '' }
            ]"
          />
        </div>
      </div>

      <div class="form-item form-item--required">
        <div class="form-item__label">
          <span>
            .
          </span>
          手机号
        </div>
        <div class="form-item__content">
          <van-field
            v-model="params.phone"
            placeholder="请输入手机号"
            clearable
            :rules="[
              { required: true, message: '' },
              { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}
            ]"
          />
          <van-field
            v-model="params.verifyCode"
            center
            clearable
            placeholder="请输入短信验证码"
            :rules="[
              { required: true, message: '' }]"
          >
            <template #button>
              <van-button size="small" type="primary" @click.prevent="getCode" :disabled="isSmsSend">{{ sendBtnText }}</van-button>
            </template>
          </van-field>
        </div>
      </div>
      <van-button :loading="subLoading" loading-text="提交中..." round type="primary" @click="onSumbit">
        提 交
      </van-button>
      <ComBacktop :bottom="50" />
    </van-form>
    </div>
    <div class="edit-container" v-if="isEidtShow">
      <div class="content">
        <van-field
          v-model="params.phone"
          placeholder="请输入手机号"
          clearable
          :rules="[
            { required: true, message: '' },
            { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}
          ]"
        />
        <van-field
          v-model="params.verifyCode"
          center
          clearable
          placeholder="请输入短信验证码"
          :rules="[
            { required: true, message: '' }]"
        >
          <template #button>
            <van-button size="small" type="primary" @click.prevent="getCode" :disabled="isSmsSend">{{ sendBtnText }}</van-button>
          </template>
        </van-field>
        <div class="submit">
          <van-button class="btn1" plain round type="info" @click="closeEditInfo">取 消</van-button>
          <van-button class="btn" round type="primary" @click="submitEditInfo">
            提 交
          </van-button>
        </div>
      </div>
    </div>
  </div>
    </header>
</template>

<script>
import { minBy } from 'lodash'
// import DateField from '@/components/date-field'
// import { validator as validateUtil } from '@/utils/validate'
import { elementInView, scrollTo } from '@/utils/dom'
import axios from 'axios'
import Vue from 'vue'
import { Picker, Popup, Uploader, Notify, Toast, Form, Field   } from 'vant'
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Uploader)
Vue.use(Notify)
Vue.use(Toast)
Vue.use(Form)
Vue.use(Field)
export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      apiUrl: 'https://api.snowtrace.club/',
      // apiUrl: 'https://test-api.snowtrace.club/',
      isEidtShow: false,
      subLoading: false,
      shipin: '',
      params: {
        reqType: 1, // 新增修改类型，请求类型 1新增 2修改
        coachNickName: '',  // 昵称
        coachAvatarUrl: '', // 头像url
        skiType: '', // 单双板
        residentResort: '', // 常驻雪场
        skiStyle: '', // 擅长教学
        desc: '', // 个人简介
        allSkiYears: '', // 雪龄
        authSkiYears: '', // 教龄
        authDoc: [], // 认证材料图片url
        personVideo: [{videoUrl: ''}], // 个人视频url
        studentVideo: [
          {videoDesc: '',videoUrl:''},
          {videoDesc: '',videoUrl:''},
          {videoDesc: '',videoUrl:''}
        ], // 学生视频url，数组
        threeHourPrice: '', // 	三小时价格 元
        dayPrice: '', // 	一天价格 元
        organizaId: '', // 教练体系表主键id
        coachLevel: '', // 	教练等级 如：1
        contactDatails: '', // 	联系方式
        verifyCode: '',
        phone: ''
      },
      photo: {
        uploader: []
      },
      // new
      valueChange: '', // 0 图片 1 多图资质 2 个人视频
      headerPurl: '', // 头像地址
      authModel: {}, // 资质上传列表
      authDoc: {uploader: []}, // 教练资质数组
      authDocIs: [], // 真正的教练资质数组地址
      personVideo:[{videoUrl:''}], //个人视频url
      studentVideo: [
        {uploader: []},
        {uploader: []},
        {uploader: []}
      ],
      skiType:'',
      showPicker: false,
      show: false,
      showCity: false,
      showSystem: false,
      showRank: false,
      value: '',
      residentResort: '',
      valueSystem: '',
      valueRank: '',
      columns: ['单板', '双板'],
      skiResortList: ['北京雪场', '崇礼雪场', '吉林雪场', '新疆雪场'],
     // systemList: ['美国-单板-AASI', '美国-双板-PSIA', '英国--BASI', '加拿大-单板-CASI', '加拿大-双板-CSIA', '澳洲--APSI', '新西兰--SBINZ', '中国--国职'],
     systemList: [],
      rankList: ['1级', '2级', '3级'],
      isSmsSend: false,
      sendBtnText: '点击发送验证码',
      timer: null,
      counter: 60
    }
  },
  created() {
    this.getCoachOrganizaList()
  },
  methods: {
    onConfirm (value, index) {
      // console.log(index)
      // console.log(value)
      if (value=='单板' || value=="双板" ) {
        this.params.skiType = index
        // console.log(this.params.skiType)
        this.skiType = value
        this.showPicker = false
      } else if (value=='北京雪场' || value=='崇礼雪场' || value=='吉林雪场' || value=='新疆雪场') {
        this.params.residentResort = index
        this.residentResort = value
        this.showCity = false
      } else if (value.name=='美国-AASI-单板' || value.name=='美国-PSIA-双板' || value.name=='英国-BASI' || value.name=='加拿大-CASI-单板' || value.name=='加拿大-CSIA-双板' || value.name=='澳洲-APSI' || value.name=='新西兰-SBINZ') {
        this.valueSystem = value.name
        this.params.organizaId = value.id
        this.showSystem = false
        this.rankList = ['1级', '2级', '3级']
        // console.log(index)
      } else if(value.name=='中国-国职') {
        this.valueSystem = value.name
        this.params.organizaId = value.id
        this.showSystem = false
        this.rankList = ['1级', '2级', '3级', '4级', '5级']
      } else {
        this.params.coachLevel = value
        this.showRank = false
      }

    },
     validator(val) {
       if(val.length>7)
      return val
    },
    // 限制上传大小
    onOversize(file) {
      // console.log(file);
      Toast('文件大小不能超过 30mb');
    },
    afterReadUpload0(file){
      this.afterRead(file, 0)
    },
    afterReadUpload1(file){
      this.afterRead(file, 1)
    },
    afterReadUpload2(file){
      this.afterRead(file, 2)
    },
    afterReadUpload3(file){
      this.afterRead(file, 3)
    },
    afterReadUpload4(file){
      this.afterRead(file, 4)
    },
    afterReadUpload5(file){
      this.afterRead(file, 5)
    },
    // 上传头像
    afterRead(file, valueChange) {
      // 此时可以自行将文件上传至服务器
      // console.log(file)
      var formDate = new FormData();
      formDate.append('file',file.file)
      // console.log(formDate)
      file.status = 'uploading';
      file.message = '上传中...';
      const url = this.apiUrl + 'upload/uploadFile'
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      axios.post(url, formDate, config).then(res => {
        // console.log(res.data)
        if(res.data.code == 200) {
          Notify({ type: 'success', message: res.data.msg });
          file.status = 'done';
          file.message = '上传成功';
          this.headerPurl = res.data.data.fileUrl
          // console.log(this.headerPurl)
          // console.log(this.valueChange)
          switch(valueChange) {
            case 0:
              this.params.coachAvatarUrl = this.headerPurl
              break
            case 1:
              this.params.authDoc.push(this.headerPurl)
              // console.log(this.params.authDoc)
              break
            case 2:
              this.params.personVideo[0].videoUrl = this.headerPurl
              console.log('个人视频',this.params.personVideo)
              // console.log(this.personVideo.uploader)
              break
            case 3:
              // console.log(this.params.studentVideo)
              this.params.studentVideo[0].videoUrl = this.headerPurl
              // console.log('学员视频1',this.params.studentVideo)
              break
            case 4:
              this.params.studentVideo[1].videoUrl = this.headerPurl
              // console.log('学员视频2',this.params.studentVideo)
              break
            case 5:
              this.params.studentVideo[2].videoUrl = this.headerPurl
              // console.log('学员视频3',this.params.studentVideo)
              break
          }
        } else {
          file.status = 'failed';
          file.message = '上传失败';
        }
      })
    },
    btn(value) {
      this.valueChange = value
    },
    deleteP0o0(index){
      this.params.coachAvatarUrl = ''
    },
    deleteP0o1(index){
      this.params.authDoc.splice(index, 1)
    },
    deleteP0o2(index){
      this.params.personVideo = [{videoUrl: ''}]
    },
    deleteP0o3(index){
      this.params.studentVideo[0].videoUrl = ''
    },
    deleteP0o4(index){
      this.params.studentVideo[1].videoUrl = ''
    },
    deleteP0o5(index){
      this.params.studentVideo[2].videoUrl = ''
    },
    deleteP0o(index) {
      // console.log(this.valueChange)
      switch(this.valueChange) {
        case 0:
          this.params.coachAvatarUrl = ''
          // console.log(this.params.coachAvatarUrl)
          break
        case 1:
          this.params.authDoc.splice(index, 1)
          // console.log(this.params.authDoc)
          break
        case 2:
          this.params.personVideo.splice(index, 1)
          // console.log('个人视频',this.params.personVideo)
          break
        case 3:
          this.params.studentVideo[0].videoUrl = ''
          // console.log(this.params.studentVideo)
          // console.log('学员视频1',this.params.studentVideo)
          break
        case 4:
          this.params.studentVideo[1].videoUrl = ''
          // console.log('学员视频2',this.params.studentVideo)
          break
        case 5:
          this.params.studentVideo[2].videoUrl = ''
          // console.log('学员视频3',this.params.studentVideo)
          break
      }
    },
    // 根据验证结果 滚动到验证错误的节点
    scrollToErrorNode (fieldObj) {
      const errorNodes = []
      Object.keys(fieldObj).forEach(field => {
        const el = document.querySelector(`[data-name=${field}]`)
        if (el) {
          const isView = elementInView(el)
          if (!isView) {
            errorNodes.push({
              name: field,
              el,
              y: el.getBoundingClientRect().y
            })
          }
        }
      })
      const minYNode = minBy(errorNodes, node => node.y)
      if (minYNode) {
        scrollTo(window, window.pageYOffset, minYNode.el.offsetTop, 800)
        const errList = fieldObj[minYNode.name]
        if (errList && errList.length) {
          const errObj = errList[0]
          const errMessage = errObj.message
          // console.log('errMessage', errMessage)
        }
      }
    },
    onSumbit () {
      let newParams = JSON.parse(JSON.stringify(this.params))
      console.log(this.params.studentVideo)
      if(newParams.studentVideo[2].videoUrl == '') {
        newParams.studentVideo.splice(2, 1)
        }
      if(this.params.studentVideo[1].videoUrl == '') {
        newParams.studentVideo.splice(1, 1)
      }
      console.log(this.params.studentVideo)
      if(newParams.coachNickName.length > 7){
        Toast('昵称 最多7个字符');
          return false;
      } else if (newParams.coachAvatarUrl == '') {
        Toast('请上传头像');
          return false;
      } else if (this.residentResort == '') {
        Toast('请选择类型');
          return false;
      } else if(this.skiType == '') {
        Toast('请选择类型');
          return false;
      }  else if (newParams.skiStyle.length > 22) {
        Toast('擅长教学最多输入22个字符');
          return false;
      } else if (newParams.desc > 80) {
        Toast('个人简介最多输入80个字符');
          return false;
      } else if (newParams.authSkiYears == '') {
        Toast('请填写教龄');
          return false;
      }  else if (newParams.authDoc == '') {
        Toast('请上传认证材料图片');
          return false;
      } else if (newParams.personVideo[0].videoUrl == ''){
        Toast('请上传个人视频');
          return false;
      } else if (newParams.studentVideo[0].videoUrl == '') {
        Toast('请上传学员视频1');
          return false;
      } else if (newParams.studentVideo[0].videoUrl && newParams.studentVideo[0].videoDesc == '') {
        Toast('请输入学员描述');
          return false;
      } else if (newParams.verifyCode == '') {
        Toast('请输入验证码');
          return false;
      }
      // console.log(this.params)
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = this.apiUrl + 'coach/moCoachApply'
      this.subLoading = true
      axios.post(url, newParams, config).then(res => {
        if (res.data.code == 200) {
          // this.clear()
          this.$router.push('/success')
          // this.$router.push({path:'/success'})
        } else {
          Toast(res.data.msg)
        }
        this.subLoading = false
      })
    },
    // 获取教练列表
    getCoachOrganizaList() {
       const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = this.apiUrl + 'enums/h5GetCoachOrganizaList'
      axios.post(url, {}, config).then(res => {
        this.systemList  = res.data.data
      })
    },
    clear() {
      // setInterval(() => {
      //     Toast('页面即将刷新');
      //     parent.location.reload()
      //   }, 1000)

        this.params.coachNickName = '',  // 昵称
        this.params.skiType = '', // 单双板
        this.params.coachAvatarUrl = '', // 头像url
        this.params.residentResort = '', // 常驻雪场
        this.params.skiStyle = '', // 擅长教学
        this.params.desc = '', // 个人简介
        this.params.allSkiYears = '', // 雪龄
        this.params.authSkiYears = '', // 教龄
        // this.params.authDoc = [], // 认证材料图片url
        // this.params.personVideo[0].videoUrl = '', // 个人视频url
        // this.params.studentVideo[0].videoDesc = '',
        // this.params.studentVideo[0].videoUrl = '',
        // this.params.studentVideo[1].videoDesc = '',
        // this.params.studentVideo[1].videoUrl = '',
        // this.params.studentVideo[2].videoDesc = '',
        // this.params.studentVideo[2].videoUrl = '',
        this.params.threeHourPrice = '', // 	三小时价格 元
        this.params.dayPrice = '', // 	一天价格 元
        this.params.organizaId = '', // 教练体系表主键id
        this.params.coachLevel = '', // 	教练等级 如：1
        this.params.contactDatails = '', // 	联系方式
        this.params.verifyCode = '',
        this.params.phone = '',

        // 数据展示
        this.photo = '',
        this.skiType = '',
        this.residentResort = '',
        this.valueSystem = '',
        this.personVideo.uploader = '',
        this.authDoc = {uploader: []},
        this.studentVideo[0].uploader = '',
        this.studentVideo[1].uploader = '',
        this.studentVideo[2].uploader = ''
        // this.studentVideo[0].videoDesc = '',
        // this.studentVideo[0].videoUrl = '',
        // this.studentVideo[1].videoDesc = '',
        // this.studentVideo[1].videoUrl = '',
        // this.studentVideo[2].videoDesc = '',
        // this.studentVideo[2].videoUrl = ''
      },
       // 正则验证
    onFailed(errorInfo) {
      // console.log('failed', errorInfo);
    },
    getCode() {
      if (this.params.phone) {
        this.isSmsSend = true
        // 开始倒计时，60s之后才能再次点击
        this.countDown()
      }
      const url = this.apiUrl + 'coach/moGetVerifyCode'
      let params = {
        phone: this.params.phone
      }
      const config = {
        headers: { "Content-Type": "application/json" },
      };
       axios.post(url, params, config).then(res => {
        // console.log(res.data)
        if(res.data.code !== 200) {
         Toast(res.data.msg)
        this.reset()
        }
      })
    },
    reset () {
        this.isSmsSend = false
        this.sendBtnText = '点击发送验证码'
        if (this.timer) {
          clearInterval(this.timer)
          this.counter = 60
          this.timer = null
        }
      },
      /**
       * 倒计时
       */
      countDown () {
        this.timer = setInterval(() => {
          this.sendBtnText = `${this.counter}秒后重新发送`
          this.counter--
          if (this.counter < 0) {
            this.reset()
          }
        }, 1000)
      },
      // 当手机号变化时，重置发送按钮
      onPhoneChange () {
        this.reset()
      },
      // 修改修改按钮
      handleEidt(){
        this.isEidtShow = true
      },
      closeEditInfo(){
        this.isEidtShow = false
      },
      // 获取修改信息
      submitEditInfo(){
        const url = this.apiUrl + 'coach/moGetCoachInfoByPhone'
        const params = {
          phone: this.params.phone,
          verifyCode: this.params.verifyCode
        }
        if(params.phone === ''|| params.verifyCode === ''){
          Toast('请填写手机号或验证码！');
          return
        }
        const config = {
          headers: { "Content-Type": "application/json" },
        };
        axios.post(url, params, config).then(res => {
          console.log(res.data, 'edit')
          if (res.data.code == 200) {
            this.isEidtShow = false
            const data = res.data.data
            this.params = {
              ...this.params,
              ...data,
              studentVideo: [
                {
                  videoDesc: data.studentVideo[0]['videoDesc'],
                  videoUrl:data.studentVideo[0]['videoUrl'],
                },
                {
                  videoDesc: data.studentVideo[1] ? data.studentVideo[1]['videoDesc'] : '',
                  videoUrl:data.studentVideo[1] ? data.studentVideo[1]['videoUrl'] : '',
                },
                {
                  videoDesc: data.studentVideo[2] ? data.studentVideo[2]['videoDesc'] : '',
                  videoUrl:data.studentVideo[2] ? data.studentVideo[2]['videoUrl'] : '',
                }
              ],
              reqType: 2,
              verifyCode: ''
            }
            // 头像
            this.photo = {
              uploader: [{url: data.coachAvatarUrl}]
            }
            // 类型
            this.skiType = this.columns[data.skiType]
            // 常驻雪场
            this.residentResort = this.skiResortList[data.residentResort]
            // 教练体系
            this.valueSystem = this.systemList.find(v => v.id === data.organizaId)['name']
            // 认证资料
            const authDocA = []
            data.authDoc.forEach(v => {
              authDocA.push({
                url: v
              })
            })
            this.authDoc = {
              uploader: authDocA
            }
            // 个人作品
            const personVideoA = []
            data.personVideo.forEach(v => {
              personVideoA.push({
                uploader: [{url: v.videoUrl}]
              })
            })
            this.personVideo = personVideoA
            // 学员视频
            this.studentVideo = [
              {uploader: [{url:  data.studentVideo[0].videoUrl}]},
              {uploader: data.studentVideo[1] ? [{url: data.studentVideo[1].videoUrl}] : []},
              {uploader: data.studentVideo[2] ? [{url: data.studentVideo[2].videoUrl}] : []}
            ]
            
          } else {
            Toast(res.data.msg)
          }
          
        })
      },
    },

}
</script>

<style lang="less" scoped>
  html,body{ width: 100%; height: 100%; overflow: scroll;}
  html::-webkit-scrollbar, body::-webkit-scrollbar{width:0px;height:0px;}
  body{margin:0;}
  .home {
   background-color: #DDF5FF;
   background-image: url('./../assets/images/bgc-new2.png');
   background-repeat: no-repeat;
   background-size: 100%;
   height: 100%;
   overflow-x: hidden;
   overflow-y: scroll;
   &::-webkit-scrollbar {
     display: none;
   }
  }
  .title, .sub-title {
    text-align: center;
  }
  .title {
    padding: 10px 10px 10px 10px;
    font-size: 20px;
    color: #fff;
    position: relative;
    top: 10px;
    text-align: left;
    left: 9px;
  }
  .sub-title {
    font-size: 18px;
  }
  .desc {
    padding:0px 20px 20px 20px;
    color: #fff;
    opacity: .8;
  }
  .form {
    margin: 0 14px;
    margin-top: 240px;
    background-color: #fff;
    border-radius: 10px;
    .title-container{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-btn{
        background: rgba(58, 109, 239, 1);
        padding: 7px 12px;
        border-radius: 30px;
        color: #fff;
        margin-right: 15px;
        .icon{
          margin-right: 5px;
          font-size: 16px;
        }
      }
    }
    .user-info-h1 {
      padding:20px;
    }
    .user-div {
      color: #666;
      padding-left: 20px;
      border-bottom: 1px dashed #ccc;
      padding-bottom: 10px;
    }
    .form-item {
      padding-bottom: 20px;
    }
    .form-item--required {
      .form-item__label {
        position: relative;
        padding-left: 12px;
        span {
          display: inline-block;
          width: 6px;
          height: 18px;
          background-color: orange;
          margin-right: 10px;
          color: orange;
        }
        .p-style {
          padding-left: 20px;
          color: #999;
          font-size: 12px;
        }
      }
    }
    .form-item__label {
      padding: 15px 0;
      font-size: 16px;
      font-weight: 400;
    }
    ::v-deep .van-field {
      padding-top: 0;
      padding-bottom: 0;
      // border: 1px solid #e0e0e0;
      border-radius: 4px;
      padding-left: 16px;
    }
    ::v-deep .van-button--round {
      padding: 0 40%;
      background-color: #557bff;
      margin: 20px 5%;
      margin-bottom: 40px;
    }
    ::v-deep .van-field__left-icon {
      display: flex;
      align-items: center;
      color: @color-text-secondary;
      font-size: 18px;
    }
    ::v-deep .van-field__control {
      padding-top: 6px;
      padding-bottom: 6px;
      padding-left: 16px;
      border-bottom: 1px solid #ddd;
    }
    ::v-deep .van-radio--horizontal {
      margin-right: 20px;
    }
  }
  .radio--vertical {
    ::v-deep .van-radio {
      margin-bottom: 12px;
    }
  }
  .checkbox--vertical {
    ::v-deep .van-checkbox {
      margin-bottom: 12px;
      .van-checkbox__icon .van-icon {
        border-radius: 2px;
      }
    }
  }
  .cell--radio ::v-deep .van-cell {
    padding-left: 0;
    padding-right: 0;
    .van-radio {
      margin-right: 8px;
    }
  }
  ::v-deep .van-button--primary {
    color: #fff;
    background-color: #557bff;
    border: 1px solid #557bff;
  }
  ::v-deep .van-field__error-message {
    margin-left: 16px;
    color: #ee0a24;
    font-size: 12px;
    text-align: left;
  }
  ::v-deep .van-uploader__file-name {
    display: none;
  }
  ::v-deep .van-uploader__file-icon {
    color: #646566;
    font-size: 20px;
    padding-bottom: 20px;
  }
  ::v-deep .van-icon-description {
    color: #557bff;
    font-size: 30px;
  }
  ::v-deep .van-icon-description:before {
    content: '\e728';
  }
  .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.7);

  }
  .edit-container{
    height: 100vh;
    background: rgba(245, 245, 245, 1);
    padding: 12px 15px;
    .content{
     border-radius: 8px;
     background: #fff;
     padding: 20px 15px;
    }
    .submit{
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
    }
    .btn1{
      width: 100%;
      margin-right: 20px;
    }
    .btn{
      width: 100%;
    }
  }
</style>
